const BankToSystemList = () =>
  import('../screens/Reconciliation/Anb/BankToSystem/List/BankToSystemList.vue');

export default [
  {
    component: BankToSystemList,
    meta: {
      activeSidebarItemId: 'anb-bank-to-system',
      authority: 'banks_recons:view',
      pageTitle: 'ANB To System',
    },
    name: 'anb-bank-to-system',
    path: '/anb-bank-to-system',
  },
];
